export class NativeApp {
  /**
   * Checks if the app is running in the native app web view.
   */
  static isNativeApp() {
    return this.isNativeAppV1() || this.isNativeAppV2();
  }
  /**
   * Checks if the app is running in the native app with version < 2.0.0 or >= 2.1.0.
   * TODO: Cleanup when v2.1.0 is the minimum version.
   */
  static isNativeAppV1() {
    return typeof window !== "undefined" && (window.native_android || window.native_ios);
  }
  /**
   * Checks if the app is running in the native app with version >= 2.0.0 and < 2.1.0.
   * TODO: Cleanup when v2.1.0 is the minimum version.
   */
  static isNativeAppV2() {
    return typeof window !== "undefined" && window.flutter_inappwebview;
  }
  static async _call(name, ...args) {
    if (this.isNativeAppV1() && window[`native_${name}`]) {
      args = args.length ? args : [""];
      args = args.map((arg) => arg === null ? "" : arg);
      window[`native_${name}`].postMessage(...args);
    } else if (this.isNativeAppV2()) {
      return await window.flutter_inappwebview.callHandler(name, ...args);
    }
  }
  /**
   * Registers a callback to be called when the app is resumed from background after being in a paused state.
   */
  static onResume(callback) {
    window.native_resume = callback;
  }
  static async share(text) {
    return this._call("share", text);
  }
  static async vibrate(impact) {
    return this._call("vibrate", impact);
  }
  static async download(url) {
    return this._call("download", url);
  }
  static async requestPermission(permission, callback) {
    if (this.isNativeAppV1()) {
      window.native_permission_request_callback = callback;
      await this._call("permission_request", permission);
    } else {
      callback(await this._call("requestPermission", permission));
    }
  }
  static async rate() {
    if (this.isNativeAppV1()) {
      return this._call("rate_dialog");
    }
    return this._call("rate");
  }
  static async scan() {
    return this._call("scan");
  }
  static async setUserId(id) {
    if (this.isNativeAppV1()) {
      return this._call("set_user_id", id ? id.toString() : null);
    }
    return this._call("setUserId", id);
  }
  static async locate(options, callback) {
    if (this.isNativeAppV1()) {
      window.native_locate_callback = callback;
      await this._call("locate", JSON.stringify(options));
    } else {
      callback(await this._call("locate", options));
    }
  }
  static async getDeviceInfo(callback) {
    if (this.isNativeAppV1()) {
      window.native_device_info_callback = callback;
      await this._call("device_info");
    } else {
      callback(await this._call("getDeviceInfo"));
    }
  }
  static async uploadImage(options, callback, loaderCallback) {
    if (this.isNativeAppV1()) {
      window.native_image_picker_callback = callback;
      window.native_image_picker_uploading = loaderCallback;
      await this._call("image_picker", JSON.stringify(options));
    } else {
      loaderCallback(true);
      try {
        callback(await this._call("uploadImage", options));
      } finally {
        loaderCallback(false);
      }
    }
  }
  static async startVirtualParticipation(options) {
    if (this.isNativeAppV1()) {
      return this._call("participation_start", JSON.stringify(options));
    }
    return this._call("startVirtualParticipation", options);
  }
  static async getFirebaseDeviceToken(callback) {
    if (this.isNativeAppV1()) {
      window.native_firebase_device_request_callback = (granted, token, platform) => {
        callback({ granted, token, platform });
      };
      await this._call("firebase_device_request");
    } else {
      callback(await this._call("getFirebaseDeviceToken"));
    }
  }
  static async showStoreListing() {
    return this._call("showStoreListing");
  }
  static async showAppTrackingTransparencyDialog() {
    return this._call("app_tracking_transparency_dialog");
  }
  static async setBadgeCount(count) {
    if (this.isNativeAppV1()) {
      return this._call("badge_update", count.toString());
    }
    return this._call("setBadgeCount", count);
  }
}
